import styles from './SpotifyEmbed.module.css';

// Default-Playlist (Trip-Mix). Maintainer kann die ID durch einen eigenen
// Trip-Mix ersetzen — Spotify liefert die Embed-URL aus jedem öffentlichen
// Playlist-Link via `open.spotify.com/embed/playlist/<id>?utm_source=generator`.
const DEFAULT_PLAYLIST_ID = '3kBIBpacxEVltzUS9HzbOs';

interface SpotifyEmbedProps {
  /** Optional eigene Playlist-ID. Default: Ballermann-Hits-Kuration. */
  playlistId?: string;
}

/**
 * Eingebettete Spotify-Playlist auf der Trip-Hauptseite. Lazy-iframe
 * (loading="lazy"), allowtransparency und ein theme-Hint sorgen dafür
 * dass der Player sich ins Sundown-Design einfügt statt mit weißem
 * Hintergrund zu kollidieren.
 */
export function SpotifyEmbed({ playlistId = DEFAULT_PLAYLIST_ID }: SpotifyEmbedProps) {
  const src = `https://open.spotify.com/embed/playlist/${encodeURIComponent(playlistId)}?utm_source=generator&theme=0`;
  return (
    <div className={styles.wrap}>
      <div className={styles.title}>🎧 Trip-Playlist</div>
      <iframe
        title="Spotify-Playlist"
        src={src}
        width="100%"
        height="232"
        frameBorder={0}
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
        className={styles.iframe}
      />
    </div>
  );
}
